module.exports = __webpack_public_path__ + "img/name-icon.6e7e69f8.svg";